// Data Integrity check descriptions (ported from legacy monitor.list.js statsDesc).

const INTEGRITY_DESCRIPTIONS: Record<string, string> = {
    INTEGRITY_1: 'Matched dispense with state RECONCILED: Qnty = Allocated',
    INTEGRITY_2: 'Sum(Accumulator.Qnty + Reserved + Surplus) = Sum(MatchedDispense.Qnty - Alloc)',
    INTEGRITY_3: 'Invoice items with state RECONCILED: OverallocationQnty = 0',
    INTEGRITY_4: 'Sum(AccumulatorTrans.Recons.MatchedDispense.QntyUsed) = Sum(MatchedDispense.Allocated)',
    INTEGRITY_5:
        'Sum(AccumulatorTrans.Recons.MatchedDispense.QntyUsed) = Sum(LineItem.Qnty)-Sum(LineItem.OverAllocQnty)',
    INTEGRITY_6: 'Sum(LineItem.OverAllocQnty) + Sum(Accumulator.Qnty) = 0 when Accumulator is overallocated',
    INTEGRITY_7: 'SUM(TransformedQuantities) = SUM(SplitTransactions x Transforms)',
    INTEGRITY_BI_MATCHES:
        'Compare number of matches in Mongo db matcheddispenses collection to number of matches in MySql matches table.',
    INTEGRITY_BI_INVOICES:
        'Compare number of invoices in Mongo db invoices collection to number of invoices in MySql vendorinvoices table.',
};

export const integrityDesc = (monitorType: string): string => INTEGRITY_DESCRIPTIONS[monitorType] ?? monitorType;
